'use client';

import Icon from './Icon';
import svg from 'sprites/triangle.svg';

export default function IconTriangle({
  className = 'w-[22px] h-[26px] fill-none stroke-white'
}: {
  className?: string;
}) {
  return <Icon id={svg.id} className={className} />;
}
